import React from 'react';
import './Divider.scss';

const Divider = ({ style }) => {
  return (
    <>
      <hr className="divider-line" style={{ ...style }}></hr>
    </>
  );
};

export default Divider;
